import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';

export const CompareMenu = {
    computed: {
        ...mapState(vplSiteStore, ['menu', 'compare'])
    },
    template: `
        <template v-if="this.menu.compare !== undefined">
            <a v-for="compareItem in this.menu.compare.ITEMS" :href="compareItem.LINK" :class="{iseditable : this.menu.favorite.EDIT_BUTTON}" class="header__top-actions-link header__top-actions-link--comp">
                <div class="header__top-actions-link-ico">
                    <svg class="icon icon-compare"><use xlink:href="#icon-compare"></use></svg>
                    <span v-if="Object.keys(this.compare).length" class="header__top-actions-link-amount">{{ Object.keys(this.compare).length }}</span>
                </div>
                <span>Сравнение</span>
            </a>
            <div v-if="this.menu.favorite.EDIT_BUTTON" class="editablearea">
                <button :onclick="this.menu.favorite.EDIT_BUTTON">Редактировать пункты меню</button>
            </div>
        </template>
    `
}